<script>
import toHTML from 'linkifyjs/html';

import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSocialFeedCustomContent',
  components: {
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpButtonLink: require('../../button-link').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    getEmbedUrl: require('../../mixins/utils.js').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
    OpenGraphPreview: require('../../components/OpenGraphPreview').default,
    CpShowImageInCard: require('../../components/ShowImageInCard').default,
    CpTruncateText: require('../../components/TruncateText').default,
    CpDisplaySocialMedia: require('../../components/DisplaySocialMedia').default,
    CpLobbyFlowDialog: require('../../dialogs/LobbyFlowDialog').default,
    LobbyActionButton: require('../actions/lobby-action-button').default,
  },
  directives: {
    marginTop: require('../../directives/margins').marginTop,
  },
  props: {
    post: Object,
    explore: Boolean,
    forShare: Boolean,
  },
  data() {
    return {
      showLikesModal: false,
      comments_count: this.post.comments_count,
      type: SectionPostTypes.CUSTOM_CONTENTS,
      showLobbyDialog: false,
    };
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
    content() {
      return toHTML(this.post.description);
    },
    videoEmbedUrl() {
      return this.getEmbedUrl(this.post['video-url']);
    },
  },
  methods: {
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.post.likes_count = this.post.likes_count + 1) : (this.post.likes_count = this.post.likes_count - 1);
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
    handleLobbyDialog() {
      this.showLobbyDialog = !this.showLobbyDialog;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="explore && post.last_activity && !forShare" style="display: flex">
            <CpCardHeaderReactions :post="post.last_activity" />
        </div>
        <hr v-if="explore && post.last_activity && !forShare" class="search-results__tick_action" /> -->
    <cp-grid>
      <cp-grid-item :span="12">
        <a :href="post.permalink" class="subheadline1 black-color">
          {{ post.title }}
        </a>
        <CpTruncateText v-if="!post.link" :content="content" />
        <CpShowImageInCard v-if="post.image" :image="post.image" :link="post.permalink" altMessage="Custom image" v-margin-top="0.5" />
        <template v-else-if="post['video-url']">
          <CpDisplaySocialMedia v-if="videoEmbedUrl !== null" :video="post['video-url']" />
          <video v-else controls preload="metadata" width="100%">
            <source :src="`${post.video}#t=0.2`" type="video/mp4" />
          </video>
        </template>
        <CpTruncateText v-if="post.link" :content="content" />
      </cp-grid-item>
    </cp-grid>

    <div class="custom-footer" v-margin-top="1">
      <a v-if="post.link" :href="post.link" style="font-size: 20px" class="heading-4">{{ post['link-text'] }}</a>
      <p class="body1 primary-color text-right">Created by: {{ post.owner.name }}</p>
    </div>

    <OpenGraphPreview v-if="post.link" :content="post.link" v-margin-top="0.5" />

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount :type="type" :id="post.id" :likesCount="post.likes_count" :commentsCount="comments_count" :handleLikesModal="handleLikesModal" />
    </div>
    <CpDialog v-if="showLikesModal && !forShare">
      <CpLikesProfiles :count-likes="post.likes_count" :id="parseInt(post.id)" :type="'custom-contents'" @close="handleLikesModal" />
    </CpDialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <LikeActionButton type="custom-contents" :id="post.id" :liked="post.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <CommentActionButton :type="type" :id="post.id" />
      </div>
      <div class="post-action-button share">
        <CpSocialShareDialog
          class="feed"
          :allow-share-feed="true"
          :type="'custom-contents'"
          :post="post"
          share-button-class="button--noborder"
          :url="post.permalink"
          :explore="explore"
          title="I wanted to share a post I found on CrowdBlue."
          description=""
          :quote="post.title"
          hashtags="crowdpac,politics,political crowdfunding"
          twitter-user="crowdpac"
        />
      </div>
      <div class="post-action-button like">
        <LobbyActionButton :handleLobbyDialog="handleLobbyDialog" title="Contact My Reps" />
      </div>
    </div>

    <CpCommentsPost v-show="!forShare" :id="post.id" :type="type" :setCount="setCommentsCount" />
    <CpLobbyFlowDialog
      v-if="showLobbyDialog"
      :showDialog="showLobbyDialog"
      type="none"
      customSubject="Concern over government spending"
      :newsArticle="post"
      :callback="handleLobbyDialog"
      shareMessageInComments
      :originalPostType="type"
      :originalPostId="post.id"
      @close="handleLobbyDialog"
    />
  </div>
</template>

<style scoped>
.title-event {
  font-size: 20px;
}
.a-hidden {
  text-decoration: none !important;
}
a.profile-link {
  color: var(--color);
}
.image {
  max-width: 100%;
  max-height: 450px;
  min-width: 100%;
}
.custom-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 500px) {
  .custom-footer {
    flex-direction: column;
    align-items: unset;
  }
}
</style>
